import { render, staticRenderFns } from "./BaseLogo.vue?vue&type=template&id=4fafe2a5&scoped=true&"
var script = {}
import style0 from "./BaseLogo.vue?vue&type=style&index=0&id=4fafe2a5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fafe2a5",
  null
  
)

export default component.exports
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QImg});
